import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { turnEncaissementStatut } from '../../flux/actions/encaissementActions';
import { getBanqueVersements, clearBanqueVersements } from '../../flux/actions/banqueversementActions';
import { IEncaissementConfirmComponent, IAuthReduxProps } from '../../types/interfaces';

import { useAlert } from "react-alert";
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';
import { getEncModeRegl } from '../../services/misc';

import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCheckCircle, faExclamationTriangle, faSpinner, faTimesCircle} from '@fortawesome/free-solid-svg-icons'
import { instantPrint } from '../pdf/PDFLink';
import { GET_PTF_V_ENCAISSEMENTS } from '../../flux/types';

const ConfirmEncaissement = ({ 
  turnEncaissementStatut,
  encaissements,
  projectGroup,
  refresh,
  setClearFilters,
  auth,
  }: IEncaissementConfirmComponent) => {
  const alert = useAlert();
  const [modal, setModal] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  const modalClosedHandle = () => {
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success, print = false) => {
    if(success?.encaissements){
      setReEnable(true);
      setModal(false);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Encaissements validés"/*, {timeout: 0}*/);
      if(print){
        instantPrint({
          documentType: "encaissements",
          data: {encaissements: success.encaissements, encTitle: "Encaissements Validés", projectName: success.projectName},
          showPreviewWatermark: false,
        });
      }
      refresh();
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const turnEncaissementStatutHandle = (action) => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    if(action === constants.VALIDATE_CHECK)
      setClearFilters(true)
    if(!encaissements?.length){
      alert.error("Veuillez sélectionner des encaissements");
      return
    }
    if(action === constants.VALIDATE_CHECK){
      setModal(true);
      return
    }
    else if(action === constants.VALIDATE_CONFIRM || action === constants.VALIDATE_CONFIRM_AND_PRINT){
      setDisableSubmit(true);
      turnEncaissementStatut(encaissements || [], projectGroup?.shortname, undefined, undefined, auth?.user?.id, auth?.user?.username, GET_PTF_V_ENCAISSEMENTS, callback, action === constants.VALIDATE_CONFIRM_AND_PRINT);
      return
    }
  }
  
  return (
    <>
      <Container className="confirmDiv" fixed="down">
        <Row className="justify-content-center">
          <Col xs="12" sm="6">
            <FormGroup>
              {/* <Label className="confirmDALabel">&nbsp;</Label> */}
              <Button
                className="btn btn-success confirmBtn"
                onClick={() => turnEncaissementStatutHandle(constants.VALIDATE_CHECK)}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;{encaissements.length ? `Valider ${encaissements.length === 1 ? "l'" : `les ${encaissements.length} `}encaissement${encaissements.length === 1 ? "" : "s"}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0${encaissements.reduce((e, t) => {return t.MONTANT ? e + t.MONTANT : e}, 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH` : `Valider`}</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>
      
      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Validation des encaissements</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="mb-4">
              <Col xs="12">
                Êtes-vous sûr de vouloir valider <b>{encaissements.length === 1 ? "l'encaissement" : `les ${encaissements.length} encaissements`}</b> ?
              </Col>
            </Row>
            {encaissements.map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12">{getEncModeRegl(e.MODE_REGL)} N°: <b>{e.REF_REGLEMENT || "-"}</b> Montant: <b>{(e.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></Col>
              </Row>
            ))}
            <Row className="justify-content-center">
              <Col xs="11" md="3">
                <Button
                  className="btn btn-info linesConfirmationBtn"
                  onClick={() => turnEncaissementStatutHandle(constants.VALIDATE_CONFIRM)}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider</Button>
              </Col>
              <Col xs="11" md="7">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={() => turnEncaissementStatutHandle(constants.VALIDATE_CONFIRM_AND_PRINT)}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider et Imprimer</Button>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      </>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { turnEncaissementStatut })(ConfirmEncaissement);
